import getConfig from 'utils/get-config';

/**
 * This should return a list of feature flags base on the current country
 * @returns Record<string, boolean>
 */
export default function getFeatureFlags(
  countryCode = ''
): Record<string, boolean> {
  const features: Record<string, boolean> = {};
  let feature_rules = undefined;

  const code = countryCode ? countryCode : getConfig().code;

  try {
    feature_rules = __FEATURE_FLAGS__;
  } catch {
    return {};
  }

  if (!feature_rules) return features;

  Object.entries(feature_rules).forEach(([key, rules]) => {
    rules = rules.filter((rule) => {
      if (!rule.country) return true;
      else {
        return (
          rule.country.findIndex(
            (c) => c.toLowerCase() === code.toLowerCase()
          ) !== -1
        );
      }
    });

    features[key] = rules.length !== 0;
  });

  return features;
}
